import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion, Variants } from "framer-motion";
import Scroll from '../../Layout/SmoothScroll';
import { useState } from "react";
function Article4() {
  const imageRef = useRef(null);

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0
  });

  const { ref: secondContainer, inView: secondInView } = useInView({
    threshold: 0
  });

  const getAnimationClass = () => {
    if (firstInView) {
      var img1 = document.getElementById("img1");
      img1.className = 'active';
      var img2 = document.getElementById("img2");
      img2.className = '';

      return "";
    }

    else if (secondInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = 'active';

      return "";
    }
  };

  const textAnimate = {
    offscreen: { y: 10, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        duration: 0.5
      }
    }
  }
  const imgAnimate = {
    offscreen: { opacity: 0 },
    onscreen: {
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        delay: 0.5,
        duration: 0.5
      }
    }
  }

  const [addClass, setAddClass] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article5');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick1 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article3');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick2 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <Scroll />
      <motion.div
        initial={"offscreen"}
        whileInView={"onscreen"}
        viewport={{ once: false, amount: 0.5 }}
        transition={{ staggerChildren: 0.25 }}
        className="magazine-wrap article-wrap"
      >
        <motion.div
          variants={imgAnimate}
          className="article-left"
        >
          {/* {getImage()} */}
          <img id="img1" className="active" src={require("../../Images/article4-left-img1.jpg")} />
          <img id="img2" className={getAnimationClass()} src={require("../../Images/article4-left-img2.jpg")} />
        </motion.div>
        <div className="article-right scroll-sec">

          <motion.div variants={textAnimate} className="article-left-mob">
            <img src={require("../../Images/article4-left-img1.jpg")} alt="" />
          </motion.div>
          <motion.div
            variants={textAnimate}
            className="hamburger-menu mb-4 mb-sm-5">
            <Link to="/">
              <img
                src={require("../../Images/hamburger-menu-icon.png")}
              />
            </Link>
          </motion.div>
          <div className="article-mob-wrap">
          <div className="" ref={firstContainer}>
            <div variants={textAnimate}>
              <h1 className="fs-xxl fw-normal mb-4 mb-sm-5 pb-3 d-inline-block lh-1"><span className="f-lora-i d-block mb-3">spinning</span> <span className="fw-semibold ls-4">A GOOD YARN</span> </h1>
            </div>
            <p className="mb-4 mb-sm-5 font-italic" variants={textAnimate}>A tale of Scottish textiles from tartan to tweed. At the V&A in Dundee a thought-provoking exhibition ‘Tartan’ explores one of Scotland’s most famous design icons, while across the Highlands and Islands there is a resurgence of artisan weaving, a cultural revival and economic success story. </p>

            <img variants={textAnimate} className="img-fluid mb-4 mb-sm-5" src={require("../../Images/article4-right-img1.jpg")} />

            <p className="font-italic text-blue" variants={textAnimate}>A tidal wave of tourists flows off the foot ferry from Mull surging up the jetty onto the tiny island of Iona. Lining the waterfront a picture-postcard row of traditional cottages; a few steps up the hill, however, an architectdesigned wooden building is the contemporary home of Iona Wool. Eye-catching sunshine-yellow felt wellies in the window draw you into a sleek store, where hanks and cones of small-batch yarns nudge up to sumptuously soft hand-knits and bespoke tweed bunnets and bags in subtle hues–all made from the island’s single-origin wool.</p>
            <div className="row align-items-center mb-4 mb-sm-5">
              <div variants={textAnimate} className="col-sm-6 mb-3">
                <p className="" variants={textAnimate}>Iona, in the Inner Hebrides is a mere three miles long by one and a half wide. It’s home to just 150 people - and 1,000 sheep, seven crofts and two farms. A decade ago, with the price of wool plummeting, fleeces sold for a pittance to carpet companies, Michael and Kate Gordon stepped in with a plan.</p>
                <p className="" variants={textAnimate}>The fleeces are now carefully rolled and sorted by hand. Wool that doesn’t make the hand-knitting grade becomes the weaving yarn used to make their signature tweeds and the felted footwear, which despite winging its way to a family of artisan makers in Finland, treads lightly on the planet.</p>
                <p className="" variants={textAnimate}>The single-ply weaving yarn has a shorter journey across the water to the Isle of Mull and the Ardalanish Mill, a  wind-powered ‘micro-mill’ in an old cowshed on a 1,500-acre organic farm, where it’s woven into cloth on two historic looms.</p>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>It is the antithesis of the highly mechanised modern textile production. This is old-school field-to-fleece-tofashion. It ticks all the boxes: small-scale, sustainable and environmentally friendly, its carbon footprint a featherlight flip-flop across the Hebridean sand.</p>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>Say tweed, of course, and ‘Harris’ is what flashes across most people’s minds, thanks to the Harris Tweed Association. Formed in 1909, its famous orb trademark ensures that only tweed from this rugged island in the Outer Hebrides - the wool spun, dyed and hand-woven here - can be called Harris Tweed. An Act of Parliament in 1993 further cemented its status with the founding of a statutory body, the Harris Tweed Authority, safeguarding it from poor imitations.</p>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>However, Harris doesn’t have a monopoly on quality tweed; woven woollen cloth has been produced across Scotland for centuries and Iona has a long history of tweed production. In the mid-19th century seven families</p>
              </div>
              <div variants={textAnimate} className="col-sm-6">
              <p className="mb-4 mb-sm-5" variants={textAnimate}>wove Iona Tweed on traditional handlooms, a practice that continued until after the Second World War.</p>
              <p className="mb-4 mb-sm-5" variants={textAnimate}>Over on the mainland, meanwhile, contemporary textile and home furnishings brand Anta has been designing a range of modern tweed fabrics, rugs and pure wool flatweave carpets – along with their signature carpet bags - on the north-east coast near Tain since it was founded in the eighties by designer Annie and architect Lachlan Stewart. The couple met at Edinburgh College of Art and in 2024 Anta will celebrate its 40th anniversary. </p>
              <p className="mb-4 mb-sm-5" variants={textAnimate}>From the outset their philosophy focused on using local, sustainable, natural materials - wool shorn from the sheep each year is the ultimate renewable resource - and preserving artisan crafts and skills. The designs are based on traditional tweeds and tartans but the colours are inspired by the Scottish landscape and seasons. ‘Cawdor’ named after the castle famous for its ‘Macbeth’ connections, takes its greens, greys and purple hues from the surrounding heather-blanketed moorland.</p>
              <p className="mb-4 mb-sm-5" variants={textAnimate}>The fabrics are woven in the Borders but turned into carpets and cushions at the factory, designed by Lachlan to resemble an agricultural shed to blend into the landscape, and powered by solar panels.</p>
              <p className="mb-4 mb-sm-5" variants={textAnimate}>Interest in traditional skills, preserving ancient crafts and ethical production is one shared by Clare Campbell, the founder of Prickly Thistle, the first new textile mill in Scotland in more than two decades, a few miles further south.</p>
              <p className="mb-4 mb-sm-5" variants={textAnimate}>In 2018 she launched a crowd-funding campaign to bankroll a pop-up textile mill, with a more permanent base, the Black House Mill, set to open a couple of years later, in a converted steading on the Black Isle. The historic building, once a grain store, stable and cattle byre was to herald a new chapter for tartan textiles.</p>
              </div>
            </div>
            







          </div>

          

          <div className="mb-4 mb-sm-5" ref={secondContainer}>
            <img
              src={require("../../Images/article4-right-img2.jpg")}
              className={"w-100 mb-4"}
              alt=""
            />
            <div className="row mb-4">
              <div className="col-6">
                <img className="img-fluid"
                  src={require("../../Images/article4-right-img3.jpg")}
                />
                <small className="">Louise Gray 2011. For her iconic collection ‘Up Your Look’, by Michael McGurk</small>
              </div>
              <div className="col-6">
                <img className="img-fluid"
                  src={require("../../Images/article4-right-img4.jpg")}
                />
                <small className="">Satin day dress, c.1865. Courtesy of Fashion Museum Bath</small>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-6">
                <p className="mb-4 mb-sm-5" variants={textAnimate}>The pop-up mill in a warehouse on the edge of Evanton got the ball rolling. Through word of mouth she sourced a number of old looms dating back to the 1920s down in the Borders.</p>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>“They’re sound pieces of equipment, made to last and incredible machines to work with.” Next she found someone to teach her the ropes. Martin Dent used to work for Hunters of Brora, the woollen mill founded in 1901 but forced to close in 2003 after producing tweed for over a century. The yarn comes from Jamiesons of Shetland and Todd & Duncan in Kinross. She now designs bespoke tartans along with a range of Prickly Thistle tartans, which are used in their capsule fashion line.</p>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>“It’s zero-waste design, the pieces made from rectangles, squares and triangles – so nothing winds up on the cutting room floor. We’re honouring the past. The kilt was traditionally made from one piece of cloth. Nothing was ever wasted.”</p>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>This is slow fashion, the opposite of the modern fashion industry with its sweatshops across Asia and giant clothes mountains creating landfill crises in countries such as</p>
                
              </div>
              <div className="col-sm-6">
                <p className="mb-4 mb-sm-5" variants={textAnimate}>Chile. It is the fashion equivalent of the field-to-forkmovement, she tells me.</p>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>“When it comes to food we now make informed decisions and invest in good, local ingredients. It should be the same for fashion. The question is how we take that to mainstream textiles. We’ve become used to clothing becoming cheaper and cheaper. We need to buy less, love more.”</p>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>The looms’ runaway train-clatter has an urgency about it as the cloth takes shape before our eyes. The steading conversion is currently on hold due to Covid and the cost of living crisis. There’s nothing like a global pandemic to focus the mind on what’s important. Which for Clare Campbell is to keep the workforce of 12 in jobs rather than gamble on new premises.</p>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>“People in the workplace were valued in the past. For us it’s about finding the right balance. Ending poverty is about creating jobs not providing cheap, disposable fashion. This is a grassroots business, regenerating skills and knowledge. We’re not luxury fashion or fast fashion - we’re ethical fashion.” Prickly Thistle also became the first B Corp certified mill in the UK.</p>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-6">
                <p className="mb-4 mb-sm-5" variants={textAnimate}>The tartans she designs are symbolic of the people or companies that commission them. She’s created tartans for whisky distilleries, Highland estates, Belladrum’s Tartan Heart music festival and even The Beano comic. For Dennis the Menace’s 70th birthday she created a tartan based on just two colours, black and red, a nod to his signature black and red striped jumper.</p>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>Prickly Thistle’s Black House Mill tartan, meanwhile, tells the story of the agricultural steading which will be converted into a mill one day, the black and grey hues mirroring the Highland slate on the old roof, the year it was built reflected in the thread counts.</p>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>Scotland’s textile heritage is bookended by tweed and tartan: tartan the loud, proud, grid-patterned plaid, tweed its subtler, more understated cousin. But what sets tartan apart is its storytelling power. Over the centuries it has become more than a textile.</p>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>The V&A Dundee’s introduction to the exhibition attempts to put it in context.</p>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>“Tartan is a  textile, a pattern, a cultural phenomenon, a byword for all things Scottish. Traditional and rebellious, adored and derided, tartan is a pattern of endless contradiction.”</p>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>Divided into five themes; Tartan and the Grid, Tartan and Innovation, Tartan and Identity,  Tartan and Power, and Transcendental Tartan, from the rules of the grid, its pattern and proportions and colours, visitors are fasttracked through its influence on fashion, architecture, graphic and product design, with film, performance and art interwoven. It’s a gallop around the globe and a rollercoaster ride through history; tartan was banned after the Jacobite rebellion, resurrected by Sir Walter Scott’s romantic makeover of the Highlands, and used by politicians, the royal family and the military over the centuries to sway, rally and rouse.</p>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>There are more than 300 objects on display, from the oldest piece of tartan dating back to the 16th century, unearthed in a peat bog in Glen Affric, to the MacBean tartan, which travelled to the moon with astronaut Alan Bean in 1969 on Apollo 12. Mannequins are dressed in outfits created by British fashion designers Vivienne Westwood and Alexander McQueen, while French fashion houses such as Dior and Chanel were also famous champions of tartan.</p>
              </div>
              <div className="col-sm-6">
                <img className="img-fluid"
                  src={require("../../Images/article4-right-img5.jpg")}
                />
                <small className="mb-4 d-block">Glen Affric tartan - Scotland’s oldest-known true tartan</small>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>There’s an Ottoman silk cape from 1922 in Gordon tartan designed by Gabrielle ‘Coco’ Chanel and a 1960s Dior blouse and kilt once worn by Wallis Simpson.</p>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>Crackly amateur footage from 1938 shows weaver Willie Meikle at work on his handloom at home in Kilbarchan. He kept a sample of every tartan he wove. Then there’s the kilt worn during the First World War at the battle of Auber’s Bridge in 1915 by Private James Calder. Still caked in mud and on loan from the Highlanders Regimental Museum at Fort George, it’s one of the most poignant artefacts. </p>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>The V&A’s exhibition takes a wide-angled look at tartan and its journey around the world. Tartan as a textile is a simple novella, but as a globetrotting design phenomenon it’s a Tolkein-esque saga.</p>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>For Clare Campbell, founding Prickly Thistle and coming to understand how tartan is perceived today in Scotland was eye-opening.</p>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>“I knew tartan was a national icon but I didn’t appreciate how little it’s valued. It’s not given the same respect as the whisky industry. It’s become something produced for tourists. It should be something we’re proud of not just something we wear at a wedding.”</p>
                <p className="mb-4 mb-sm-5" variants={textAnimate}>A view she is setting out to change. The new wave of artisan makers and designers spearheading a weaving revival across the Highlands and Islands are writing tweed and tartan’s next chapter. And it looks set to be a page-turner. </p>
                <hr />
                <small className="">Tartan at the V&A continues until 14th January 2024 <br/>vam.ac.uk</small>
              </div>
            </div>
          </div>
          </div>
        </div>
      </motion.div>
      <div className="btns-group">
        <button className="btn nxtPrv-btn" onClick={handleClick1}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
        </button>
        <button className="btn home-btn" onClick={handleClick2}> Contents </button>
        <button className="btn nxtPrv-btn" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
        </button>
      </div>
      <button className={addClass ? 'active fold' : 'fold'} onClick={handleClick}></button>

      <div className={addClass ? 'active1 unfold' : 'unfold'}></div>
    </motion.div>

  );
}

export default Article4;
